var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"p-0 d-lg-none",attrs:{"cols":"12"}},[_c('last-searchs'),_c('search-results')],1)}
var staticRenderFns = []

export { render, staticRenderFns }